<form [formGroup]="credentialsForm" (ngSubmit)="iniciarSesion()">
  <div>
    <app-mensajes [code]="code" [titulo]="titulo" [detalle]="detalle"></app-mensajes>
    <div class="register-photo" style="background-color:rgb(255,255,255);">
      <div class="form-container">
        <div class="image-holder">
          <a routerLink="/" style="text-decoration: none;">
            <img src="assets/img/DNM/logo_20.png" class="top-img" style="padding-left: 4.5%;">
            <div style="font-size: 2em; ">
              <p style="color: #313945; left: -10%;">Ventanilla Electrónica</p>
            </div>
          </a>
        </div>
        <div class="form" style="align-self: center!important;">
          <div class="error-section">
            <div class="pretty-alert pretty-alert--error" *ngIf="detalle">
              <div class="pretty-alert--message">
                <p [innerHTML]="detalle"></p>
              </div>
            </div>
          </div>
          <div class="loading-section" *ngIf="visibleSpinner">
            <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
            <h3>Espera un momento... </h3>
          </div>
          <div class="loading-section" *ngIf="successLogin">
            <i class="pi pi-check-circle" style="font-size: 2rem; color: rgb(21, 120, 21);"></i>
            <p>Inicio de sesión correcto</p>
          </div>
          <ng-container *ngIf="!visibleSpinner && !successLogin">
            <h3 style="text-align: center;">Ingreso Usuarios</h3>
            <div class="input-group">
              <input type="email" required formControlName="correo" id="correo" autocomplete="off" autofocus
                placeholder="Correo electrónico" class="ui-inputtext ui-widget" pInputText>
              <span *ngIf="credentialsForm.get('correo').hasError('pattern')">
                <p-message class="custom-message-login" severity="error"
                  text="Verifique el correo electrónico ingresado"></p-message>
              </span>
            </div>
            <div class="input-wrapper" style="margin-bottom: 1rem;">
              <input type="password" required formControlName="pass" id="pass" autocomplete="off"
                placeholder="Contraseña" pInputText class="ui-inputtext ui-widget">
            </div>
            <div class="input-wrapper password-help-row" style="margin-bottom: 1.5rem;">
              <a routerLink="/auth/reset-pass" style="color: #0719E3;">¿Olvidaste tu contraseña?</a>
              <a
                href="assets/docs/instructivo-ventanilla-cambio-contrasena-desbloqueo.pdf"
                target="_blank"
                rel="noopener noreferrer"
                class="password-help-button"
                title="Clic para abrir instrucciones para cambio de contraseña o desbloqueo de usuario"
                aria-label="Abrir instrucciones para cambio de contraseña o desbloqueo de usuario"
              >
                <i class="fa fa-question-circle"></i>
              </a>
            </div>
            <div class="input-wrapper" style="margin-bottom: 1rem;">
              <button type="submit" style="background-color: #313945; border: #0D1175;" label="Iniciar sesión" pButton [disabled]="!credentialsForm.valid"></button>
            </div>
            <hr class="separator">
            <div class="input-wrapper">
              <p style="color: #212121;">¿No tienes una cuenta? 
                <a routerLink="/auth/registro" class="btn-registerForm" style="color: #0719E3;">Regístrate</a>
              </p>
              <p style="color: #212121; padding-top: 3%;">¿Tienes un código de confirmación?
                <a routerLink="/auth/confirm-user/" [queryParams]="{ref: 'login'}" style="color: #0719E3;">finaliza el registro</a>
              </p>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</form>
